/**********************************************************************************
*
* CONTACT
*
**********************************************************************************/
if(document.getElementById('f_topic_file'))
{
    var __options = { buttonText: 'Choisir un fichier',  hint: ' ou le déposer ici' }

    new InputFile(__options);

    var __field = document.getElementById('f_topic_file') ;
    var __allowed = __field.getAttribute('data-allowed'); 
    __field.addEventListener('change', function()
    {
        var __selected = this.files[0];
        var __type = __selected.type;
        if(__allowed && (__type == "" || __allowed.indexOf(__type) < 0))
        {
            var myModal = new Modal({
                            content: __field.parentNode.parentNode.parentNode.parentNode.querySelector('.form-section-label-info').innerHTML
                        });
            myModal.on('show', function(myModal, event)
            {
                event;
                myModal._html.footer.childNodes[0].remove();
            });
            myModal.show();
            __field.setAttribute('value', '');
            __field.parentNode.querySelector('.inf__hint').innerHTML = __options.hint;
        }
    });
}

if(document.getElementById('globalWarningContainer'))
{
    var myModal = new Modal({ content: document.getElementById('globalWarning').innerHTML });
    myModal.on('show', function(myModal, event) { event; myModal._html.footer.childNodes[0].remove(); });
    myModal.show();
    document.getElementById('globalWarningContainer').remove();
}

